var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountBread(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#00adef"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7333 26.4958V25.0333C45.7333 23.3581 44.3753 22 42.7 22H21.0333C19.3581 22 18 23.3581 18 25.0333V26.4958C18 26.6454 18.1213 26.7667 18.2708 26.7667H45.4625C45.6121 26.7667 45.7333 26.6454 45.7333 26.4958Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28.7708V38.0333C18 39.7086 19.3581 41.0667 21.0333 41.0667H42.7C44.3753 41.0667 45.7333 39.7086 45.7333 38.0333V28.7708C45.7333 28.6213 45.6121 28.5 45.4625 28.5H18.2708C18.1213 28.5 18 28.6213 18 28.7708ZM24.9333 35.8667C24.9333 36.3453 24.5453 36.7333 24.0667 36.7333H23.2C22.7214 36.7333 22.3333 36.3453 22.3333 35.8667V35C22.3333 34.5214 22.7214 34.1333 23.2 34.1333H24.0667C24.5453 34.1333 24.9333 34.5214 24.9333 35V35.8667Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBread);
export default __webpack_public_path__ + "static/media/accountBread.723ca363bc4331c7b8d3ed5cbee0a6ed.svg";
export { ForwardRef as ReactComponent };